import { AppIcon, RawSVG } from 'core/components/icons/icon.type';

export const iconCheckmark: AppIcon = {
  svgData: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 6.5L9 17.5L4 12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' as RawSVG,
  name: 'checkmark',
};
